"use client";

import urls from '@/utils/urls/urls';
import axios from 'axios';
import React, { useState } from 'react';
import toast from 'react-hot-toast';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        try {
            const response = await axios.post(urls?.contact, formData);

            // console.log("response >", response)

            if (response?.data?.data) {
                toast.success('Message sent successfully!');
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
            } else {
                alert('Error sending message.');
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error sending message.');
        }
    };

    return (
        <form onSubmit={handleSubmit} id="contact-form">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <div className="form-icon">
                            <i className="far fa-user-tie" />
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <div className="form-icon">
                            <i className="far fa-envelope" />
                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                placeholder="Your Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group">
                <div className="form-icon">
                    <i className="far fa-pen" />
                    <input
                        type="text"
                        className="form-control"
                        name="phone"
                        placeholder="Your Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>
            <div className="form-group">
                <div className="form-icon">
                    <i className="far fa-pen" />
                    <input
                        type="text"
                        className="form-control"
                        name="subject"
                        placeholder="Your Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>
            <div className="form-group">
                <div className="form-icon">
                    <i className="far fa-comment-lines" />
                    <textarea
                        name="message"
                        cols={30}
                        rows={5}
                        className="form-control"
                        placeholder="Write Your Message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>
            <button type="submit" className="theme-btn">
                Send Message <i className="far fa-paper-plane" />
            </button>
        </form>
    );
};

export default ContactForm;
